import { defineNuxtPlugin, useNuxtApp } from '#imports';

export default defineNuxtPlugin(() => ({
    provide: {
        analytics: {
            productToAnalytics(product) {
                const { $analytics } = useNuxtApp();

                return {
                    item_id: product.code,
                    item_name: product.attributes?.product_name ?? product.name,
                    quantity: Number(product.amount) ?? 1,
                    price: $analytics.priceWithoutTax(product),
                };
            },
            priceWithoutTax(product) {
                const { $analytics } = useNuxtApp();
                const price = product.attributes?.price ?? product.price;

                try {
                    const taxAmount = Number(product.attributes?.tax_class?.[0].replace('%', '').replace(',', '.')) / 100;

                    return Number($analytics.roundTo(Number(price) / (1 + taxAmount)));
                } catch (e) {
                    return Number(price);
                }
            },
            getCurrency(product) {
                const { $i18n } = useNuxtApp();

                if (product?.attributes?.currency?.[0]) {
                    return product.attributes.currency[0];
                }

                switch ($i18n.locale.value) {
                    default:
                    case 'fi-FI':
                        return 'EUR';
                }
            },
            roundTo(num, length = 2) {
                return (Math.round( (Number(num) + Number.EPSILON) * 100) / 100).toFixed(length);
            },
        },
    },
}));
